import { render, staticRenderFns } from "./PatientDetail.vue?vue&type=template&id=3bd19fd9&scoped=true"
import script from "./PatientDetail.vue?vue&type=script&lang=js"
export * from "./PatientDetail.vue?vue&type=script&lang=js"
import style0 from "./PatientDetail.vue?vue&type=style&index=0&id=3bd19fd9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bd19fd9",
  null
  
)

export default component.exports